import { Notification } from './notificationAction'

export enum NotificationTypes {
  NOTIFICATION_UPDATE = 'notification_update',
}

export interface INotificationState {
  notifications: Notification[]
}

interface INotificationUpdateAction extends INotificationState {
  type: typeof NotificationTypes.NOTIFICATION_UPDATE
}

export type NotificationActionTypes = INotificationUpdateAction
export type NotificationState = INotificationState

export const initialState: NotificationState = {
  notifications: []
}

export const notificationReducer = (initialState: NotificationState, action: NotificationActionTypes): NotificationState => {
  switch (action.type) {
    case NotificationTypes.NOTIFICATION_UPDATE:
      return {
        ...initialState, notifications: action.notifications
      }
    default:
      return initialState
  }
}
